import React, { useEffect } from 'react';
import { IonApp, IonLoading } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { useSelector, useDispatch } from 'react-redux';
import AppActions, { AppSelectors } from 'redux/AppRedux';
import { AuthSelectors } from 'redux/AuthRedux';
import { Toast, Refresher } from 'containers/layout';
import AppUrlListener from './AppUrlListener';
import AuthRoutes from './AuthRoutes';
import UserRoutes from './UserRoutes';

function App() {
  const loaded = useSelector(AppSelectors.selectLoaded);
  const user = useSelector(AuthSelectors.selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AppActions.startup());
  }, []);

  return (
    <IonApp>
      <IonLoading isOpen={!loaded} message="Loading..." />
      <Toast />
      {loaded && (
        <IonReactRouter>
          <AppUrlListener />
          {user && <Refresher />}
          {user ? <UserRoutes user={user} /> : <AuthRoutes />}
        </IonReactRouter>
      )}
    </IonApp>
  );
}

export default App;
